import { render, staticRenderFns } from "./NotificationStatusComponent.vue?vue&type=template&id=3e9b1bca"
import script from "./NotificationStatusComponent.js?vue&type=script&lang=js&external"
export * from "./NotificationStatusComponent.js?vue&type=script&lang=js&external"
import style0 from "./NotificationStatusComponent.vue?vue&type=style&index=0&id=3e9b1bca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports